//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { shallowEqual, useSelector } from 'react-redux'



//  ----------------------------------------------------------------------------
//  Selectors
//  ----------------------------------------------------------------------------

//  -- Examples data ------------------
const selectore = (state) => state.one_game_gallery;
//  -- Examples array selector --------



export const useOneGameGallery = () =>{
    const selectedData = useSelector(selectore, shallowEqual)
    return selectedData;
}